import { render, staticRenderFns } from "./PluginInfo.vue?vue&type=template&id=24367e4a&scoped=true&"
import script from "./PluginInfo.vue?vue&type=script&lang=ts&"
export * from "./PluginInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PluginInfo.vue?vue&type=style&index=0&id=24367e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24367e4a",
  null
  
)

export default component.exports